var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "community-b-navigation-bar" },
    [
      _c("div", { staticClass: "top-filter-area" }, [
        _c(
          "div",
          { staticClass: "filter-left" },
          [
            _c("el-input", {
              staticClass: "search-input",
              attrs: { placeholder: "请输入名称", clearable: "" },
              model: {
                value: _vm.searchName,
                callback: function ($$v) {
                  _vm.searchName = $$v
                },
                expression: "searchName",
              },
            }),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
              [_vm._v("搜索")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
              [_vm._v("添加导航")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "", stripe: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "编号", prop: "id", align: "center", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "标题", prop: "extra.title", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "所属板块", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.getBlockText(scope.row.extra.block)) +
                        "\n            "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "封面图", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.extra.cover
                      ? _c("div", { staticClass: "table-image-preview" }, [
                          _c("img", {
                            staticClass: "table-preview-img",
                            attrs: {
                              src: _vm.getImageUrl(scope.row.extra.cover),
                              alt: "封面图",
                            },
                          }),
                        ])
                      : _c("div", { staticClass: "table-image-placeholder" }, [
                          _c("i", { staticClass: "el-icon-picture-outline" }),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "活动时间", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.extra.startTime) +
                          " - " +
                          _vm._s(scope.row.extra.endTime)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "启用", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#67C23A",
                        "inactive-color": "#dcdfe6",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleVisible(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enable", $$v)
                        },
                        expression: "scope.row.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "排序",
              prop: "extra.sort",
              align: "center",
              width: "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "pagination-container",
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerTitle,
            visible: _vm.drawerVisible,
            direction: "rtl",
            size: "38%",
            "before-close": _vm.handleDrawerClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.formData, "label-width": "100px" },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSubmit($event)
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "标题",
                        prop: "title",
                        rules: [
                          {
                            required: true,
                            message: "请输入标题",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入标题" },
                        model: {
                          value: _vm.formData.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "title", $$v)
                          },
                          expression: "formData.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "跳转页面",
                        prop: "redirectPage",
                        rules: [
                          {
                            required: true,
                            message: "请选择跳转页面",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.formData.redirectPage,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "redirectPage", $$v)
                            },
                            expression: "formData.redirectPage",
                          },
                        },
                        _vm._l(_vm.pageList, function (item) {
                          return _c("el-option", {
                            key: item.pageUrl,
                            attrs: {
                              label: item.pageName,
                              value: item.pageUrl,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "显示时间段",
                        prop: "dateRange",
                        rules: [
                          {
                            required: true,
                            message: "请选择显示时间段",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          clearable: false,
                        },
                        model: {
                          value: _vm.formData.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "dateRange", $$v)
                          },
                          expression: "formData.dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "排序序号",
                        prop: "sort",
                        rules: [
                          {
                            required: true,
                            message: "请输入排序序号",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入排序序号" },
                        model: {
                          value: _vm.formData.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "sort", _vm._n($$v))
                          },
                          expression: "formData.sort",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否显示",
                        prop: "enabled",
                        rules: [
                          {
                            required: true,
                            message: "请选择是否显示",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.enabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "enabled", $$v)
                            },
                            expression: "formData.enabled",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "展示平台",
                        prop: "platforms",
                        rules: [
                          {
                            required: true,
                            message: "请选择展示平台",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.formData.platforms,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "platforms", $$v)
                            },
                            expression: "formData.platforms",
                          },
                        },
                        [
                          _c("el-checkbox", { attrs: { label: 2 } }, [
                            _vm._v("支付宝"),
                          ]),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: 1 } }, [
                            _vm._v("微信"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "封面",
                        prop: "cover",
                        rules: [
                          {
                            required: true,
                            message: "请上传封面图片",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("input", {
                        ref: "fileInput",
                        staticStyle: { display: "none" },
                        attrs: { type: "file", accept: "image/*" },
                        on: { change: _vm.handleFileChange },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "upload-demo",
                          on: { click: _vm.handleImageClick },
                        },
                        [
                          _vm.formData.cover
                            ? _c("div", { staticClass: "preview-cover" }, [
                                _c("img", {
                                  staticClass: "cover-preview-img",
                                  attrs: {
                                    src: _vm.getImageUrl(_vm.formData.cover),
                                    alt: "封面",
                                  },
                                }),
                              ])
                            : _c("div", { staticClass: "upload-placeholder" }, [
                                _c("i", {
                                  staticClass: "el-icon-picture-outline",
                                }),
                              ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c("el-button", { on: { click: _vm.handleDrawerClose } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览导航",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览图片" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }